/* assets/trepsa-step-landing.js — Schritt 7: Podestbelag */
(() => {
  "use strict";

  const PACK_M2 = 2.22;

  function esc(s) {
    return String(s ?? "")
      .replaceAll("&", "&amp;").replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;").replaceAll('"', "&quot;");
  }

  function init() {
    const root = document.querySelector("[data-trepsa-landing]");
    if (!root) return;

    let landingProducts = [];
    try {
      landingProducts = JSON.parse(root.querySelector("[data-landing-config]")?.textContent || "[]") || [];
      landingProducts = landingProducts.filter(p => p.variantId && p.variantId !== "null");
    } catch { landingProducts = []; }

    const landingsWrap = root.querySelector("[data-landing-list]");
    const addLandBtn   = root.querySelector("[data-landing-add]");
    const landingFields= root.querySelector("[data-landing-fields]");
    const landingBtns  = root.querySelectorAll("[data-landing-toggle]");
    const landingCalcEl= root.querySelector("[data-landing-calc]");
    const calcM2El     = root.querySelector("[data-landing-calc-m2]");
    const calcQtyEl    = root.querySelector("[data-landing-calc-qty]");
    const calcProdEl   = root.querySelector("[data-landing-calc-product]");

    const norm = (s) => String(s || "").trim().toLowerCase();
    const digits = (raw) => String(raw || "").replace(/[^\d]/g, "");

    function newLanding() { return { length: "", width: "", count: 1 }; }
    const state = { landing: false, landings: [newLanding()] };

    function landingError(o) {
      const l = Number(o.length), w = Number(o.width);
      if (o.length && (l <= 0 || l > 10000)) return `Länge ${l} mm ist ungültig (max. 10000 mm).`;
      if (o.width && (w <= 0 || w > 10000)) return `Breite ${w} mm ist ungültig (max. 10000 mm).`;
      return null;
    }

    function landingHTML(o, i) {
      const err = landingError(o);
      const canDel = state.landings.length > 1;
      const l = Number(o.length), w = Number(o.width), c = Number(o.count) || 1;
      const m2 = (l && w) ? (l * w * c) / 1000000 : 0;
      return `
        <div class="trepsa-s4__entry" data-landing-index="${i}">
          <div class="trepsa-s4__entryHead">
            <span class="trepsa-s4__entryTitle">Podest ${i + 1}${m2 ? ` <em style="font-weight:700;opacity:.6;">${m2.toFixed(2)} m²</em>` : ""}</span>
            ${canDel ? `<button class="trepsa-s4__delBtn" type="button" data-landing-del="${i}">Löschen</button>` : ""}
          </div>
          <div class="trepsa-s4__fieldRow3">
            <div class="trepsa-s4__field">
              <label class="trepsa-s4__fieldLabel">Anzahl</label>
              <input class="trepsa-s4__input" type="text" inputmode="numeric" pattern="[0-9]*"
                placeholder="1" data-landing-input="count" value="${esc(String(o.count || 1))}">
            </div>
            <div class="trepsa-s4__field">
              <label class="trepsa-s4__fieldLabel">Länge (mm)</label>
              <input class="trepsa-s4__input ${err && err.includes("Länge") ? "is-error" : ""}" type="text"
                inputmode="numeric" pattern="[0-9]*" placeholder="z.B. 1200"
                data-landing-input="length" value="${esc(o.length)}">
            </div>
            <div class="trepsa-s4__field">
              <label class="trepsa-s4__fieldLabel">Breite (mm)</label>
              <input class="trepsa-s4__input ${err && err.includes("Breite") ? "is-error" : ""}" type="text"
                inputmode="numeric" pattern="[0-9]*" placeholder="z.B. 900"
                data-landing-input="width" value="${esc(o.width)}">
            </div>
          </div>
          ${err ? `<div class="trepsa-s4__inlineError">${esc(err)}</div>` : ""}
        </div>`;
    }
    function renderLandings() { if (landingsWrap) landingsWrap.innerHTML = state.landings.map(landingHTML).join(""); }

    function findLandingProduct() {
      if (!landingProducts.length) return null;
      let s1 = {};
      try { s1 = JSON.parse(localStorage.getItem("trepsa_step1") || "{}") || {}; } catch {}
      const decor = s1.decor || null;
      if (!decor) return landingProducts[0];
      return landingProducts.find(p => norm(p.decorName) === norm(decor)) || landingProducts[0];
    }

    function calcLanding() {
      if (!state.landing) return { qty: 0, m2: 0, product: null };
      let totalM2 = 0;
      for (const o of state.landings) {
        const l = Number(o.length), w = Number(o.width), c = Number(o.count) || 1;
        if (l > 0 && w > 0) totalM2 += (l * w * c) / 1000000;
      }
      if (totalM2 <= 0) return { qty: 0, m2: 0, product: null };
      const product = findLandingProduct();
      const packM2 = Number(String(product?.m2PerPack || "").replace(",", ".")) || PACK_M2;
      return { qty: Math.ceil(totalM2 / packM2), m2: totalM2, product, packM2 };
    }

    function updateLandingCalc() {
      if (!landingCalcEl) return;
      const { qty, m2, product, packM2 } = calcLanding();
      if (!state.landing || !qty) { landingCalcEl.style.display = "none"; return; }
      if (calcM2El)   calcM2El.textContent   = m2.toFixed(2);
      if (calcQtyEl)  calcQtyEl.textContent  = qty + "×";
      if (calcProdEl) calcProdEl.textContent = product ? product.title : `à ${(packM2 || PACK_M2).toString().replace(".", ",")} m²`;
      landingCalcEl.style.display = "";
    }

    function emit() {
      const { qty, product } = calcLanding();
      const priceCents = (product && qty) ? (Number(product.price || 0) * qty) : 0;
      const landings = state.landing
        ? state.landings
            .filter(o => o.length && o.width && !landingError(o))
            .map(o => ({ length: o.length, width: o.width, count: Number(o.count) || 1 }))
        : [];
      window.dispatchEvent(new CustomEvent("trepsa:landing:update", {
        detail: {
          landing: state.landing,
          landings,
          landingVariantId: product ? product.variantId : null,
          landingQty: qty,
          priceCents,
        }
      }));
    }

    function saveState() {
      try {
        localStorage.setItem("trepsa_landing", JSON.stringify({
          landing: state.landing,
          landings: state.landings.map(o => ({ length: o.length, width: o.width, count: o.count }))
        }));
      } catch (_) {}
    }

    function refresh() { updateLandingCalc(); emit(); saveState(); }

    landingBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        const val = btn.getAttribute("data-landing-toggle") === "yes";
        state.landing = val;
        landingBtns.forEach((b) => b.setAttribute("aria-pressed", b === btn ? "true" : "false"));
        if (landingFields) landingFields.style.display = val ? "" : "none";
        if (!val) { state.landings = [newLanding()]; renderLandings(); }
        refresh();
      });
    });

    addLandBtn?.addEventListener("click", () => {
      state.landings.push(newLanding());
      renderLandings();
      refresh();
    });

    root.addEventListener("click", (e) => {
      const t = e.target instanceof Element ? e.target : null;
      const del = t?.closest("[data-landing-del]");
      if (del) {
        const i = Number(del.getAttribute("data-landing-del"));
        if (state.landings.length > 1) { state.landings.splice(i, 1); renderLandings(); refresh(); }
      }
    });

    root.addEventListener("input", (e) => {
      const t = e.target instanceof Element ? e.target : null;
      const input = t?.closest("[data-landing-input]");
      if (!input) return;
      const idx = Number(t.closest("[data-landing-index]")?.getAttribute("data-landing-index"));
      const key = input.getAttribute("data-landing-input");
      const o   = state.landings[idx];
      if (!o) return;
      const clean = digits(t.value);
      if (key === "count") {
        if (clean === "") { o.count = ""; t.value = ""; refresh(); return; }
        o.count = Math.max(1, Math.min(99, Number(clean) || 1));
        t.value = o.count;
      } else {
        o[key] = clean;
        t.value = clean;
      }
      const card = t.closest("[data-landing-index]");
      const err  = landingError(o);
      card?.querySelectorAll(".trepsa-s4__inlineError").forEach(el => el.remove());
      if (err) card?.insertAdjacentHTML("beforeend", `<div class="trepsa-s4__inlineError">${esc(err)}</div>`);
      card?.querySelector(`[data-landing-input="length"]`)?.classList.toggle("is-error", !!(err && err.includes("Länge")));
      card?.querySelector(`[data-landing-input="width"]`)?.classList.toggle("is-error", !!(err && err.includes("Breite")));
      const l = Number(o.length), w = Number(o.width), c = Number(o.count) || 1;
      const m2 = (l && w) ? (l * w * c) / 1000000 : 0;
      const titleEl = card?.querySelector(".trepsa-s4__entryTitle");
      if (titleEl) titleEl.innerHTML = `Podest ${idx + 1}${m2 ? ` <em style="font-weight:700;opacity:.6;">${m2.toFixed(2)} m²</em>` : ""}`;
      refresh();
    });

    root.addEventListener("focusout", (e) => {
      const t = e.target instanceof Element ? e.target : null;
      const input = t?.closest('[data-landing-input="count"]');
      if (!input) return;
      const idx = Number(t.closest("[data-landing-index]")?.getAttribute("data-landing-index"));
      const o = state.landings[idx];
      if (o && (o.count === "" || !Number(o.count))) {
        o.count = 1;
        input.value = "1";
        refresh();
      }
    });

    window.addEventListener("trepsa:step1:update", refresh);

    // Gespeicherten Zustand wiederherstellen
    (function restore() {
      try {
        const saved = JSON.parse(localStorage.getItem("trepsa_landing") || "null");
        if (saved && typeof saved === "object") {
          state.landing = !!saved.landing;
          if (Array.isArray(saved.landings) && saved.landings.length) {
            state.landings = saved.landings.map(o => ({
              length: String(o.length || ""), width: String(o.width || ""), count: Number(o.count) || 1
            }));
          }
          if (state.landing) {
            landingBtns.forEach((b) => b.setAttribute("aria-pressed", b.getAttribute("data-landing-toggle") === "yes" ? "true" : "false"));
            if (landingFields) landingFields.style.display = "";
          }
        }
      } catch (_) {}
    })();

    renderLandings();
    refresh();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();